module.exports = {
    _DEFAULT_BANNER_PRIORITY_ORDER_FIELD_NAMES: ['on_clearance', 'on_sale', 'is_new'],
    _BANNER_FIELD_NAME_TO_CLASS_NAME_MAP: {
        on_sale: 'fmcy-menu-item-weekly-sale-banner',
        is_new : 'fmcy-menu-item-is-new-banner',
        on_clearance: 'fmcy-menu-item-clearance-banner'
    },
    _STRAINS_WITH_IMAGES: [
        'hybrid', 'indica', 'sativa'
    ],
    _CATEGORIES_WITH_IMAGES: [
        'concentrates', 'edibles', 'pre-rolls', 'other'
    ],
    getBannerClassName: function () {
        var self = this;
        var bannerClassName;
        _.each(self.options.bannerPriority, function (bannerFieldName) {
            if (!bannerClassName) {
                if (bannerFieldName === 'on_sale') {
                    if (self.model.isOnSale()) {
                        bannerClassName = self._BANNER_FIELD_NAME_TO_CLASS_NAME_MAP[bannerFieldName];
                    }
                } else if (self.model.get(bannerFieldName)) {
                    bannerClassName = self._BANNER_FIELD_NAME_TO_CLASS_NAME_MAP[bannerFieldName];
                }
            }
        });
        return bannerClassName;
    },
    getStrainTitleImageClassName: function () {
        var strainTitleImgClass = '';
        var strainGroup = this.model.getStrainGroupCode();
        if (strainGroup &&
            this._STRAINS_WITH_IMAGES.indexOf(strainGroup) !== -1)
        {
            strainTitleImgClass =
                'fmcy-menu-item-thumb-category-' +
                strainGroup +
                '-title';
        } else if (this.model.get('category') && this._CATEGORIES_WITH_IMAGES.indexOf(this.model.get('category')) !== -1) {
            strainTitleImgClass =
                'fmcy-menu-item-thumb-category-' +
                this.model.get('category').toLowerCase() +
                '-title';
        }
        return strainTitleImgClass;
    },
    getEffectsAttrsString: function () {
        var effectsAttrs = '';
        if (this.model.get('menu_headline')) {
            effectsAttrs = this.model.get('menu_headline');
        } else {
            effectsAttrs = this.model.get('menu_effects_general');
        }
        return effectsAttrs;
    },
    getMedicalAttrsString: function () {
        var medicalAttrs = '';
        if (this.model.get('menu_sub_headline')) {
            medicalAttrs = this.model.get('menu_sub_headline');
        } else {
            medicalAttrs = this.model.get('menu_effects_medical');
        }
        return medicalAttrs;
    },
    _getProductLocations: function (includeOutOfStock) {
        var self = this;
        var allLocations = self.options.locations;
        if (includeOutOfStock == true) {
          return  allLocations;
        }
        var productVariants = self.model.get('variants');
        var productLocations = new Backbone.Collection();
        productVariants.each(function (productVariant) {
            _.each(productVariant.get('locations'), function (pvl) {
                if (pvl.quantity && pvl.quantity > 0 && !pvl.temp_removed) {
                    var location = allLocations.get(pvl.location_id);
                    if (self.options.showOnlineProductLocations ||
                        location && location.get('type') === self.model.PRODUCT_LOCATION_TYPES.STORE)
                    {
                        productLocations.add(location);
                    }
                }
            });
        });
        return productLocations;
    },
    _shouldRenderProductLocations: function () {
        if (this.options.showProductLocations) {
            return this._getProductLocations().size() > 0;
        }
        return false;
    }
};



/** WEBPACK FOOTER **
 ** ./assets/js/common/menu/common/menu-item-mixin.js
 **/